<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="审核信息" size="80%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <div v-if="formData.wkFeeApplyOrderList.length>0">
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '36px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 36, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }"
                            :data="formData.wkFeeApplyOrderList">
                  <vxe-column type="checkbox" width="40"/>
                  <vxe-column field="orderNo" title="工单号" width="150"/>
                  <vxe-column field="brandName" title="品牌"  key="brandName"/>
                  <vxe-column field="partsApplyNo" title="配件申请单号" key="partsApplyNo" width="120"/>
                  <vxe-column field="partsCode" title="配件编码" key="partsCode" width="120"/>
                  <vxe-column field="partsName" title="配件名称" key="partsName" width="120"/>
                  <vxe-column field="partsQty" title="配件数量" key="partsQty"/>
                  <vxe-column field="factPartsCode" title="实收配件编码" key="factPartsCode" width="150">
                    <template slot-scope="{ row,index }" >
                      <el-input type="text"  v-model="row.factPartsCode" style="width: 8vw;" ></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="factPartsQty" title="实收数量" key="factPartsQty" width="150">
                    <template slot-scope="{ row,index }" >
                      <el-input type="text"  v-model="row.factPartsQty"  style="width: 8vw;" ></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="barcode" title="条码" key="barcode" width="150">
                    <template slot-scope="{ row,index }" >
                      <el-input type="text"  v-model="row.barcode" style="width: 8vw;" disabled></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="content" title="申请内容" width="250" key="content">
                    <template slot-scope="{ row,index }">
                      <el-input type="text"  v-model="row.content" style="width: 8vw;" disabled></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="barcode" title="申请金额" key="applyAmount" width="100">
                    <template slot-scope="{ row,index }">
                      <el-input type="number"  v-model="row.applyAmount" style="width: 8vw;" disabled></el-input>
                    </template>
                  </vxe-column>

                  <vxe-column field="barcode" title="核销比例（%）" key="hxRate" width="150">
                    <template slot-scope="{ row,index }">
                      <el-input type="number"  v-model="row.hxRate"  style="width: 8vw;"  @input="changeCheckAmount(row)"></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="checkAmount" title="审核金额" key="checkAmount" width="100">
                    <template slot-scope="{ row,index }">
                      <el-input type="text" readonly v-model="row.checkAmount" style="width: 8vw;" @change="sumCheckAmount" ></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="checkResult" title="审核结果" key="checkResult" width="120">
                  </vxe-column>
                  <vxe-column field="rejectRemark" title="说明" key="rejectRemark" width="250">
                  </vxe-column>
                </vxe-table>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>
    <excel-upload
      ref="excelUpload"
      title="批量导入工单审核明细"
      :data="{applyId:formData.id}"
      url="/basic/wkFeeApply/importCheckOrders"
      temp-url="/admin/sys-file/local/file/wkFeeApplyOrdersCheck.xlsx"
      @refreshDataList="refreshChange"
    ></excel-upload>
  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";
// 文件上传
import textUpload from "@/components/formItem/textUpload.vue"
import ExcelUpload from "@/components/upload/excelByData.vue";


export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'confirmNo', 'dataId', 'wf', 'obj', ],
  components: {
    ExcelUpload,
    textUpload,
  },
  created() {
    console.log(this.wf)
    this.formData.id = this.dataId
    if (this.wf) {
      this.exchangeNo = this.wf.orderNo
      this.formData.processId = this.wf.processId
      this.formData.taskId = this.wf.taskId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }
    if (this.wf.wfView) {
      this.wfView = this.wf.wfView
      if (this.wfView.indexOf('?') != -1) {
        var queryString = this.wfView.split('?')[1];
        let params = new URLSearchParams(queryString);
        this.formData.index = params.has('index') ? params.get('index') : 0;
        console.log("index", this.formData.index)
      }
    }
    console.log(this.obj)
    if (this.obj) {
			this.feeTypeName = this.obj.feeTypeName;
      if (this.formData.index && this.formData.index == "2" && this.feeTypeName && this.feeTypeName.indexOf('安装维修费用核销') > -1) {
        this.showSettleAmountFlag = true
      } else if(this.formData.index && this.formData.index == "3" && this.feeTypeName && this.feeTypeName.indexOf('三包配件核销') > -1) {
        this.showSettleAmountFlag = true
      } else if(this.formData.index && this.formData.index == "1" && this.feeTypeName && this.feeTypeName.indexOf('面板核销') > -1) {
        this.showSettleAmountFlag = true
      }
		}
    this.getWkFeeApplyOrderList()
  },
  data() {
    return {

      showSettleAmountFlag: false,
      feeTypeName: '',

      uploadFileUrl: api.uploadFileUrl,
      logisticsCompaniesList: [],
      exchangeNo: '',
      checkFileObj: null,

      formData: {
        id: null,
        processId: null,
        taskId: null,
        messageContent: null,

        index: null,

        checkAmount: null,
        checkFile: null,
        checkNote: null,
        assignType: null,
        wkFeeApplyOrderList:[],
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    changeCheckAmount(row){
      // if(!row.factPartsQty){
        let applyAmount = !row.applyAmount?0:row.applyAmount;
        let hxRate = !row.hxRate?0:row.hxRate;
        row.checkAmount = (applyAmount * hxRate /100).toFixed(2)
      // }else{
        // if(row.factPartsQty > row.partsQty){
        //   this.$message.error("实收数量不能大于配件数量");
        //   return
        // }
        // let partsQty = row.factPartsQty
        // let sitePrice = row.sitePrice
        // let hxRate = !row.hxRate?0:row.hxRate;
        // row.checkAmount = (partsQty*sitePrice * hxRate /100).toFixed(2)

      // }

    },
    sumCheckAmount(){
      var checkAmount = 0
      this.formData.wkFeeApplyOrderList.forEach(item => {
        if (item.checkResult == 1){
          checkAmount = Number(checkAmount) + Number(item.checkAmount)
        }else if(item.checkResult == 2){
          item.checkAmount = 0
        }
      })
      this.formData.checkAmount = checkAmount
    },
    importOrders(){
      this.$refs.excelUpload.show()
    },
    //导入返回
    refreshChange(data){
      data.forEach(importItem => {
        var isIn = false;
        this.formData.wkFeeApplyOrderList.forEach(item => {
          if (item.id == importItem.id){
            item.checkResult = importItem.checkResult
            item.checkAmount = importItem.checkAmount
            item.rejectRemark = importItem.rejectRemark
          }
        })
      })
      this.sumCheckAmount()
    },
    getWkFeeApplyOrderList(){
      this.$http({
        url: api.wkFeeApply.addDataUrl + "getWkFeeApplyOrderList",
        method: 'post',
        data: {id: this.formData.id},
      }).then(res => {
        this.formData.wkFeeApplyOrderList = res.data.data
      })

    },
    // 考核的确认
    siteAppeal() {
      if (this.checkFileObj && this.checkFileObj.length > 0) {
        this.formData.checkFile = this.checkFileObj[0]['url']
      }
      // if (!this.formData.assignType) {
      //   this.$message.error('指派人员不能为空');
      //   return false
      // }
      if (this.formData.wkFeeApplyOrderList.length>0){
        var errorMsg = null
        this.formData.wkFeeApplyOrderList.forEach(item => {
          var itemErrorMsg = null;
          if (item.checkResult!=null && item.checkResult == 1){
          //   if (item.checkAmount == null || item.checkAmount <= 0) {
          //     if (itemErrorMsg == null) {
          //       itemErrorMsg = "工单:" + item.orderNo + "审核结果通过,审核金额必填且必须大于0";
          //     } else {
          //       itemErrorMsg = itemErrorMsg + ",审核结果通过,审核金额必填且必须大于0";
          //     }
          //   }
          // }else if (item.checkResult!=null && item.checkResult == 2){
          //   if (!item.rejectRemark) {
          //     if (itemErrorMsg == null) {
          //       itemErrorMsg = "工单:" + item.orderNo + "审核结果不通过,不通过原因必填";
          //     } else {
          //       itemErrorMsg = itemErrorMsg + ",审核结果不通过,不通过原因必填";
          //     }
          //   }
          // }else{
          //   if (itemErrorMsg == null) {
          //     itemErrorMsg = "工单:" + item.orderNo + "审核结果必填";
          //   } else {
          //     itemErrorMsg = itemErrorMsg + ",审核结果必填";
          //   }
           }
          if (errorMsg){
            errorMsg = errorMsg+'<br/><br/>'+ itemErrorMsg
          }else{
            errorMsg = itemErrorMsg
          }

        })
        if (errorMsg){
          this.$message({
            message:errorMsg,
            dangerouslyUseHTMLString: true,
            type: "error"
          });
          return false;
        }
      }


      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.wkFeeApply.addDataUrl + "sitecheck1",
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$message.success('确认成功')
          this.$emit('closeD')
          this.$emit('flushed')
          this.$mask.close()
        }).catch(() => {
          this.$mask.close()
        })
      })
    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      // 物流公司
      loadDictData(dictType.logisticsCompanies).then(res => {
        this.logisticsCompaniesList = []
        res.data.data.forEach(item => {
          this.logisticsCompaniesList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  },
  mounted() {
    this.loadDictData()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
